import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

export const loginEspnPlatform = async (email: string, sessionId: string, passcode: string, accessAuthToken: string, pocToken: string, signal?: AbortSignal): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/fantasy_leagues/login_fantasy_platform`;
    const data = {
      integration_name: "espn",
      user_email: email,
      sessionid: sessionId,
      passcode: passcode,
      pocToken: pocToken,
      // year: "2025",
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify(data),
      signal: signal,
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("ESPN login failed");
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("Something went wrong while trying to log in with ESPN", error);
    showErrorToast("Something went wrong while trying to log in with ESPN");
    throw error;
  }
};
